<template>
	<tr>
	    <td class="image-column"  v-bind:class="'image-column line-' + item.id">
	        <img v-if="item.image_url != ''" v-lazy="item.image_url" :alt="item.sku">
	        <img v-if="item.image_url == ''" src="/img/nopic.svg" :alt="item.sku">
	    </td>
	    <td class="sku-column blah">
	        <vue-autosuggest
	        	v-model="item.sku" :suggestions="suggestions" :input-props="{placeholder:'Enter a SKU...', class:'form-control line-id', dataCol:'sku'}" 
	        	:get-suggestion-value="getSku" :ref="item.sku"
	        	@keyup="onInputChange" @selected="onSelected" @blur="processUpdate"
	        	>  
				<template slot-scope="{suggestion}">
					<div class="d-flex justify-content-start align-items-center">
					   	<div class="mr-4">
						   	<img v-if="suggestion.item.image_url" class="image" v-lazy="suggestion.item.image_url">
						   	<img v-if="!suggestion.item.image_url" class="image" src="/img/nopic.svg">
					   	</div>
					   	<div class="flex-grow-1">
					    	<span class="item-description">{{ suggestion.item.description }}</span><br>
					    	<span class="item-sku">{{ suggestion.item.sku }}</span>
					   	</div>
					   	<div class="attribute-column">
						   	<p class="attribute"><span class="attribute-label">Category:</span><span class="attribute-value">{{ suggestion.item.category }}</span></p>
						   	<p class="attribute"><span class="attribute-label">Style:</span><span class="attribute-value">{{ suggestion.item.style }}</span></p>
						   	<p class="attribute"></p>
					   	</div>
					   	<div class="attribute-column">
						   	<p class="attribute"><span class="attribute-label">Material:</span><span class="attribute-value">{{ suggestion.item.material }}</span></p>
						   	<p class="attribute"><span class="attribute-label">Grade:</span><span class="attribute-value">{{ suggestion.item.grade }}</span></p>
						   	<p class="attribute"><span class="attribute-label">Size:</span><span class="attribute-value">{{ suggestion.item.size }}</span></p>
					   	</div>
					</div>
				</template>
			</vue-autosuggest>
	    </td>
	    <td>
	        {{item.description}}
	    </td>
	    <td>
	        {{item.category}}
	    </td>
	    <td>
	        {{item.brand}}
	    </td>
	    <td>
	        {{item.material}}
	    </td>
	    <td>
	        {{item.style}}
	    </td>
	    <td>
	        {{item.color}}
	    </td>
	    <td>
	        {{item.size}}
	    </td>
	    <td>
	        {{item.grade}}
	    </td>
	    <td class="numeric">
	        <input type="text" class="form-control usd-input" data-col='qty_to_buy' v-model="item.qty_to_buy" @focus="selectText" @blur="processUpdate" @keydown.up="lineUp" @keydown.down="lineDown" @keydown.page-down="lineDown($event, 25)" @keydown.page-up="lineUp($event, 25)" @keydown.right="cellRight">
	    </td>
	    <td class="numeric">
	        <input type="text" class="form-control usd-input" data-col='max_cost' v-model="item.max_cost" @focus="selectText" @blur="processUpdate" @keydown.up="lineUp" @keydown.down="lineDown" @keydown.page-down="lineDown($event, 25)" @keydown.page-up="lineUp($event, 25)" @keydown.left="cellLeft" @keydown.right="cellRight">
	    </td>
	    <td class="numeric">
	        <input type="text" class="form-control yen-input" data-col='max_tax_out' v-model="item.max_tax_out" @focus="selectText" @blur="processUpdate" @keydown.up="lineUp" @keydown.down="lineDown" @keydown.page-down="lineDown($event, 25)" @keydown.page-up="lineUp($event, 25)" @keydown.left="cellLeft" @keydown.right="cellRight">
	    </td>
	    <td class="numeric">
	        <input type="text" class="form-control yen-input" data-col='max_tax_in' v-model="item.max_tax_in" @focus="selectText" @blur="processUpdate" @keydown.up="lineUp" @keydown.down="lineDown" @keydown.page-down="lineDown($event, 25)" @keydown.page-up="lineUp($event, 25)" @keydown.left="cellLeft">
	    </td>
<!--	    <td>
		    <button class="btn btn-small x-btn-icon" @click="deleteRow(item.id)"><i class='bi-trash'></i></button>
	    </td>-->
	</tr>
</template>
<script>
import Vue from 'vue';
import debounce from 'debounce';
import VueAutosuggest from "vue-autosuggest";
import accounting from 'accounting';

Vue.use(VueAutosuggest);

import VueLazyload from 'vue-lazyload';
Vue.use(VueLazyload, {
  preLoad: 1.3,
  attempt: 3
});


var buylistitem = {
	props: ['lineIndex','lineId','sku','description','brand','category','material','styleName','color','grade','size','image_url','qty_to_buy','max_cost','max_tax_out','max_tax_in','buylistId'],
	mounted: function () {
		
		this.item.max_cost = accounting.formatMoney(this.item.max_cost);
		this.item.max_tax_out = accounting.formatMoney(this.item.max_tax_out, "¥", 2);
		this.item.max_tax_in = accounting.formatMoney(this.item.max_tax_in, "¥", 2);
		if (this.item.id === false) {
			this.save(this.item);
		}
	},	
	filters: {
		'usd': value => {
			return accounting.formatMoney(value, "$", 2);
		},
		'yen': value => {
			return accounting.formatMoney(value, "¥", 2);
		},
	},
	methods: {
		selectText(e) {
			console.log(e.target);
			e.target.select();
		},
		getSku(item) {
			return item.item.sku;
		},
	    onSelected(suggestion) {
		    var item = Object.assign({}, suggestion.item);
		    item.id = this.item.id;
		    item.index = this.lineIndex;
		    this.item = item;
		    this.$emit('update-line', item);
		    this.processUpdate();
	    },
	    onInputChange: debounce(async function (e) {
		   var request = axios.get('/buylists/skuautocomplete/' + e.target.value);
		   var response = await request;
		   this.suggestions = [response];
	    }, 500),
	    cellRight(e) {
		    const col = e.target.dataset.col == undefined ? 'sku' : e.target.dataset.col;
		    if ( e.target.selectionStart == e.target.value.length) {
			    switch (col) {
				    case "sku":
				    		document.querySelector("#line-list > tbody > tr:nth-child(" + (this.lineIndex + 1) + ") input[data-col=\"qty_to_buy\"]").focus();
						break;
				    case "qty_to_buy":
				    		document.querySelector("#line-list > tbody > tr:nth-child(" + (this.lineIndex + 1) + ") input[data-col=\"max_cost\"]").focus();
					    break;
				    case "max_cost":
				    		document.querySelector("#line-list > tbody > tr:nth-child(" + (this.lineIndex + 1) + ") input[data-col=\"max_tax_out\"]").focus();
					    break;
				    case "max_tax_out":
				    		document.querySelector("#line-list > tbody > tr:nth-child(" + (this.lineIndex + 1) + ") input[data-col=\"max_tax_in\"]").focus();
					    break;
				    case "max_tax_in":
				    default:
				    	break;
			    }
		    }
	    },
	    cellLeft(e) {
		    const col = e.target.dataset.col == undefined ? 'sku' : e.target.dataset.col;
		    if ( e.target.selectionStart == 0) {
			    switch (col) {
				    case "max_cost":
				    		document.querySelector("#line-list > tbody > tr:nth-child(" + (this.lineIndex + 1) + ") input[data-col=\"qty_to_buy\"]").focus();
					    break;
				    case "max_tax_out":
				    		document.querySelector("#line-list > tbody > tr:nth-child(" + (this.lineIndex + 1) + ") input[data-col=\"max_cost\"]").focus();
					    break;
				    case "max_tax_in":
				    		document.querySelector("#line-list > tbody > tr:nth-child(" + (this.lineIndex + 1) + ") input[data-col=\"max_tax_out\"]").focus();
				    	break;
				    case "qty_to_buy":
				    case "sku":
				    default:
				    	break;
			    }
			    
		    }
	    },
	    lineUp(e, num) {
		    const col = e.target.dataset.col == undefined ? 'sku' : e.target.dataset.col;
		    if (num === undefined) num = 1;
		    num = Math.max(0, (this.lineIndex - num)) + 1;
		    if (col == "sku") {
			    document.querySelector("#line-list > tbody > tr:nth-child(" + num + ") input.line-id").focus();
		    } else {
			    document.querySelector("#line-list > tbody > tr:nth-child(" + num + ") input[data-col=\"" + col + "\"]").focus();
		    }
		    
	    },
	    lineDown(e, num) {
		    const col = e.target.dataset.col == undefined ? 'sku' : e.target.dataset.col, lineCount = document.querySelectorAll("#line-list > tbody > tr").length;
		    if (num === undefined) num = 1;
		    num = Math.min(lineCount, (num + this.lineIndex + 1));
		    if (col == "sku") {
			    document.querySelector("#line-list > tbody > tr:nth-child(" + num + ") input.line-id").focus();
		    } else {
			    document.querySelector("#line-list > tbody > tr:nth-child(" + num + ") input[data-col=\"" + col + "\"]").focus();
		    }
		    
	    },
        async save(data) {
	        var obj = Object.assign({}, data);
	        Object.keys(obj).forEach(key => {
		       if (obj[key] == '' || obj[key] == false)  {
			       delete obj[key];
		       }
	        });
			obj.max_cost = accounting.unformat(this.item.max_cost);
			obj.max_tax_out = accounting.unformat(this.item.max_tax_out);
			obj.max_tax_in = accounting.unformat(this.item.max_tax_in);
	        obj.buylist_id = this.buylistId;
            var response = await axios.post('/buylistlines', obj);
            if (response.status < 300 && response.status >= 200 && response.data && response.data.id) {
	            this.item = response.data;
	        } else {
		        this.error('Could not create line');
			   	this.$emit('line-create-failure');
	        }
        },
        async update(data) {
	        document.querySelectorAll('#line-' + data.id + ' td').forEach(function (el) {
		        el.classList.add("pending");
		        el.classList.remove("success");
		        el.classList.remove("failure");
	        });
			data.max_cost = accounting.unformat(data.max_cost);
			data.max_tax_out = accounting.unformat(data.max_tax_out);
			data.max_tax_in = accounting.unformat(data.max_tax_in);
            data._method = 'PUT';
            if (data.index !== undefined) delete data.index;
            var p = axios.post('/buylistlines/' + data.id, data);
            
            if (typeof cb == "function") p.catch((e) => {
	            
		        document.querySelectorAll('#line-' + data.id + ' td').forEach(function (el) {
			        el.classList.add("failure");
			        el.classList.remove("success");
			        el.classList.remove("pending");
		        });
		        
	            this.error(e);
	            this.$emit('line-update-failure');
	        }).then(() => {
		        
		        document.querySelectorAll('#line-' + data.id + ' td').forEach(function (el) {
				    el.classList.remove("failure");
					el.classList.remove("pending");
			        el.classList.add("success");
			        setTimeout(function () {
				        el.classList.remove("success");
				        el.classList.remove("pending");
				        el.classList.remove("failure");
			        }, 1500);
		        });
	        });
        },
        async deleteRow(id) {
            var response = await axios.delete('/buylistlines/' + id);
            
            if (response.status < 300 && response.status >= 200) {
		      // destroy the vue listeners, etc
		      this.$destroy();
			  this.$el.classList.add("removing");
			  var el = this.$el;
			  setTimeout(function() {
				   el.classList.add("removed");
				   el.parentNode.removeChild(el);
			  }, 500);		     
	        }
        },	  
        error(string) {
	        console.log(string);
        },
        processUpdate: debounce(function (e) {
	        this.update(Object.assign({}, this.item));
        })
	},
    data() {
	  return {
		  item: {
			  id: this.lineId,
			  sku: this.sku,
			  description: this.description,
			  brand: this.brand,
			  category: this.category,
			  material: this.material,
			  style: this.styleName,
			  color: this.color,
			  grade: this.grade,
			  size: this.size,
			  image_url: this.image_url,
			  qty_to_buy: this.qty_to_buy,
			  max_cost: this.max_cost,
			  max_tax_out: this.max_tax_out,
			  max_tax_in: this.max_tax_in
		  },
		  suggestions: []
	  }  
    },
    
	name: 'buylist-item'
};


export default buylistitem;

</script>